import React, { useEffect, useState } from "react";
import axios from "axios";
import API_BASE_URL from "../config"; // ✅ Ensure this is: https://api.cityzoom.in/api

const SupportTickets = () => {
  const [email, setEmail] = useState(null);
  const [tickets, setTickets] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const ticketsPerPage = 10;

  // ✅ On component mount, get email from localStorage
  useEffect(() => {
    const storedEmail = localStorage.getItem("email");
    console.log("📦 Retrieved email from localStorage:", storedEmail);

    if (storedEmail) {
      setEmail(storedEmail);
    } else {
      console.warn("⚠️ No email found in localStorage.");
    }
  }, []);

  // ✅ Fetch tickets when email is available
  useEffect(() => {
    console.log("🔁 SupportTickets component rendered with email:", email);

    if (!email) {
      console.warn("⚠️ Email is undefined or null. Skipping fetch.");
      return;
    }

    console.log("📧 Fetching tickets for:", email);

    axios
      .get(`${API_BASE_URL}/support/support?email=${email}`)
      .then((res) => {
        console.log("✅ Raw API response:", res.data);

        const ticketList = Array.isArray(res.data?.data)
          ? res.data.data
          : Array.isArray(res.data)
          ? res.data
          : [];

        console.log("✅ Processed ticket list:", ticketList);
        setTickets(ticketList);
      })
      .catch((err) => {
        console.error("❌ Error fetching tickets:", err);
        setTickets([]);
      });
  }, [email]);

  // Pagination
  const indexOfLastTicket = currentPage * ticketsPerPage;
  const indexOfFirstTicket = indexOfLastTicket - ticketsPerPage;
  const currentTickets = tickets.slice(indexOfFirstTicket, indexOfLastTicket);
  const totalPages = Math.ceil(tickets.length / ticketsPerPage);

  const handlePrev = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  return (
    <div>
      <style>{`
        .ticket-container {
          margin: 20px;
        }

        table {
          width: 100%;
          border-collapse: collapse;
          font-family: Arial, sans-serif;
        }

        th, td {
          border: 1px solid #ddd;
          padding: 12px;
        }

        th {
          background-color: #f4f4f4;
          text-align: left;
        }

        .pagination {
          margin-top: 15px;
          display: flex;
          justify-content: center;
          gap: 10px;
        }

        .pagination button {
          padding: 6px 12px;
          border: none;
          background-color: #007bff;
          color: white;
          cursor: pointer;
        }

        .pagination button:disabled {
          background-color: #ccc;
          cursor: not-allowed;
        }
      `}</style>

      <div className="ticket-container">
        <h2>My Support Tickets</h2>

        {!email ? (
          <div style={{ textAlign: "center", color: "red" }}>
            ⚠️ Unable to find your email. Please log in again.
          </div>
        ) : (
          <>
            <table>
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>User ID</th>
                  <th>Email</th>
                  <th>Issue</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {currentTickets.length === 0 ? (
                  <tr>
                    <td colSpan="5" style={{ textAlign: "center" }}>
                      No tickets found
                    </td>
                  </tr>
                ) : (
                  currentTickets.map((ticket, index) => (
                    <tr key={ticket.id}>
                      <td>{indexOfFirstTicket + index + 1}</td>
                      <td>{ticket.user_id}</td>
                      <td>{ticket.mail}</td>
                      <td>{ticket.message}</td>
                      <td>{ticket.status}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>

            {tickets.length > 0 && (
              <div className="pagination">
                <button onClick={handlePrev} disabled={currentPage === 1}>
                  Prev
                </button>
                <span>
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  onClick={handleNext}
                  disabled={currentPage === totalPages}
                >
                  Next
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default SupportTickets;
